import { AppForm }                  from 'components/App/AppForm';
import React                        from 'react';
import type { StandistRole }        from 'constants/StandistRoleReference';
import type { STANDIST_FORM_MODES } from 'forms/StandistForm/StandistForm';
import { MODE_ADD_FOR_EXHIBITOR }   from 'forms/StandistForm/StandistForm';
import { MODE_VIEW }                from 'forms/StandistForm/StandistForm';
import UserStandRoleModel           from 'models/UserStandRoleModel';
import Standists                    from './Standists';
import FormattedMessageWrapper      from './FormattedMessageWrapper';
import { ACCESS_LOGIN, EMPTY }      from 'constants/NotificationReferences';
import NotificationModel            from 'models/NotificationModel';
import UserModel                    from 'models/UserModel';
import { ApiCollection }            from 'collections/ApiCollection';
import {
  ROLE_STANDIST_AGENCY,
  ROLE_STANDIST_DECORATOR,
  ROLE_STANDIST_EXHIBITOR,
}                                   from 'constants/StandistRoleReference';
import SendNotificationForm         from 'forms/SendNotificationForm';
import StandistForm, {
  MODE_ADD,
  MODE_EDIT,
}                                   from 'forms/StandistForm/StandistForm';
import { Collection }               from '@mathquis/modelx';
import StandModel                   from 'models/StandModel';

export const ExhibitorStandists = (props: {
  externalSync: boolean;
  mode: STANDIST_FORM_MODES;
  onSuccess: () => void;
  stand: StandModel;
  standistCollection: Collection<UserModel>;
  userStandRoleCollection: ApiCollection<UserStandRoleModel>;
}) => {
  let title = null;
  if (props.mode === MODE_ADD) {
    title = <FormattedMessageWrapper id="Ajouter Exposant" />;
  } else if (props.mode === MODE_EDIT) {
    title = <FormattedMessageWrapper id="Modifier Exposant" />;
  } else if (props.mode === MODE_VIEW) {
    title = <FormattedMessageWrapper id="Exposant" />;
  }

  return (
    <StandistStandists
      {...props}
      standistFormModalTitle={title}
      standistRole={ROLE_STANDIST_EXHIBITOR}
    />
  );
};

export const DecoratorStandists = (props: {
  externalSync: boolean;
  mode: STANDIST_FORM_MODES;
  onSuccess: () => void;
  stand: StandModel;
  standistCollection: Collection<UserModel>;
  userStandRoleCollection: ApiCollection<UserStandRoleModel>;
}) => {
  let title = null;
  if (props.mode === MODE_ADD || props.mode === MODE_ADD_FOR_EXHIBITOR) {
    title = <FormattedMessageWrapper id="Ajouter Décorateur" />;
  } else if (props.mode === MODE_EDIT) {
    title = <FormattedMessageWrapper id="Modifier Décorateur" />;
  } else if (props.mode === MODE_VIEW) {
    title = <FormattedMessageWrapper id="Décorateur" />;
  }

  return (
    <StandistStandists
      {...props}
      standistFormModalTitle={title}
      standistRole={ROLE_STANDIST_DECORATOR}
    />
  );
};

export const AgencyStandists = (props: {
  externalSync: boolean;
  mode: STANDIST_FORM_MODES;
  onSuccess: () => void;
  stand: StandModel;
  standistCollection: Collection<UserModel>;
  userStandRoleCollection: ApiCollection<UserStandRoleModel>;
}) => {
  let title = null;
  if (props.mode === MODE_ADD) {
    title = <FormattedMessageWrapper id="Ajouter Agence" />;
  } else if (props.mode === MODE_EDIT) {
    title = <FormattedMessageWrapper id="Modifier Agence" />;
  } else if (props.mode === MODE_VIEW) {
    title = <FormattedMessageWrapper id="Agence" />;
  }

  return (
    <StandistStandists
      {...props}
      standistFormModalTitle={title}
      standistRole={ROLE_STANDIST_AGENCY}
    />
  );
};

interface StandistStandistsProps {
  externalSync: boolean;
  mode: STANDIST_FORM_MODES;
  onSuccess: () => void;
  stand: StandModel;
  standistCollection: Collection<UserModel>;
  standistFormModalTitle: React.JSX.Element | null;
  standistRole: StandistRole;
  userStandRoleCollection: ApiCollection<UserStandRoleModel>;
}

class StandistStandists extends React.Component<StandistStandistsProps> {
  public render() {
    const {
      standistCollection,
      standistRole,
      userStandRoleCollection,
    } = this.props;

    return (
      <Standists
        handleOnClick={this.handleOpenStandistFormModal}
        standistCollection={standistCollection}
        standistRole={standistRole}
        userStandRoleCollection={userStandRoleCollection}
      />
    );
  }

  private handleOpenSendNotificationFormModal = (
    notificationTag: string,
    notificationToSend: NotificationModel,
  ) => {
    const { externalSync, onSuccess, stand } = this.props;

    AppForm.open(SendNotificationForm, {
      externalSync,
      model: notificationToSend,
      notificationTag,
      onSuccess,
      selectedRows: [stand],
      standCollectionFull: new ApiCollection(StandModel),
    }, {
      okText: <FormattedMessageWrapper id="Envoyer" />,
      title: <FormattedMessageWrapper id="Envoyer une notification" />,
    });
  };

  private handleOpenStandistFormModal = (user: UserModel) => {
    const {
      mode,
      onSuccess,
      stand,
      standistCollection,
      standistFormModalTitle,
      standistRole,
      userStandRoleCollection,
    } = this.props;

    let currentUserStandRole = userStandRoleCollection.find(
      (userStandRole: UserStandRoleModel) => {
        return userStandRole.userIri === user.iri && standistRole === userStandRole.standistRole;
      },
    );

    if (!currentUserStandRole) {
      currentUserStandRole = new UserStandRoleModel({
        stand: stand.iri,
        standistRole,
      });
    }

    AppForm.open(
      StandistForm,
      {
        mode,
        onSuccess: (openSendNotificationFormModal: boolean, emailOrPasswordChanged: boolean, users: string[] = []) => {
          if (openSendNotificationFormModal) {
            this.handleOpenSendNotificationFormModal(
              !emailOrPasswordChanged ? EMPTY.tag : ACCESS_LOGIN.tag,
              new NotificationModel({ users }),
            );
          } else {
            onSuccess();
          }
        },
        stand,
        standistCollection,
        standistRole,
        user,
        userStandRole: currentUserStandRole,
      },
      {
        title: standistFormModalTitle,
        width: 1024,
      },
    );
  };
}
